import {
	type ChatStorePrivateState,
	type Trace,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const getConversationTraces = (
	state: ChatStorePrivateState,
	conversationId: string,
): Trace[] => state.conversations[conversationId]?.traces ?? [];
